// Stub for rehackt - this app doesn't use React.
// rehackt is pulled in transitively by @apollo/client via @smeetz/compliance-common.
// It tries to require("react") which doesn't exist in this Vue app.
// This stub exports an empty object so nothing breaks.
module.exports = {};
